import { FC } from 'react';

type RenderIfProps = {
  condition: boolean;
};

const RenderIf: FC<RenderIfProps> = (props) => {
  const { condition = false, children } = props;
  const isConditionMetAndHasChildren = condition === true && !!children;

  if (isConditionMetAndHasChildren) {
    return <>{children}</>;
  }
  return null;
};

export { RenderIf as default, RenderIf };
export type { RenderIfProps };
